<script setup lang="ts">
import type { GrammarBadgeProps } from './component-types';

const props = withDefaults(defineProps<GrammarBadgeProps>(), {
  type: 'neutral',
  emphasis: 'default',
  size: 'md',
  topLabel: '',
  bottomLabel: '',
  leftLabel: '',
  label: '',
  secondaryLabel: '',
  mediaElevation: false,
  topIconTemplate: '',
  leadingIconTemplate: '',
  trailingIconTemplate: '',
  fullWidth: false,
});
</script>

<template>
  <tpg-badge v-bind="props" />
</template>
